const PuertoRicoSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112183)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M20.0004 0C13.4572 0 7.64826 3.14242 3.99951 8H36.0012C32.3525 3.14242 26.5435 0 20.0004 0Z"
        fill="#D80027"
      />
      <path
        d="M20.0004 39.999C26.5435 39.999 32.3525 36.8566 36.0012 31.999H3.99951C7.64826 36.8566 13.4572 39.999 20.0004 39.999Z"
        fill="#D80027"
      />
      <path
        d="M0 20C0 21.3699 0.138125 22.7076 0.400547 24H39.5996C39.862 22.7076 40 21.3699 40 20C40 18.6301 39.8619 17.2924 39.5995 16H0.400547C0.138125 17.2924 0 18.6301 0 20H0Z"
        fill="#D80027"
      />
      <path
        d="M5.85785 5.85742C-1.95262 13.6679 -1.95262 26.3312 5.85785 34.1418C9.08543 30.9142 12.1896 27.8101 20 19.9996L5.85785 5.85742Z"
        fill="#0052B4"
      />
      <path
        d="M8.09426 14.7832L9.38918 18.7688H13.5803L10.1898 21.2323L11.4846 25.218L8.09426 22.7547L4.70371 25.218L5.99887 21.2323L2.6084 18.7688H6.79918L8.09426 14.7832Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112183">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default PuertoRicoSvg;
